import React from 'react'

import { Trans, useTranslation } from 'react-i18next'

interface Props {
  minUsers: number
  yearlyPrice: string
}

const EduPricing: React.FC<Props> = ({ minUsers, yearlyPrice }) => {
  const { t } = useTranslation()
  return (
    <>
      <p className="text-md mb-1.5">
        <Trans i18nKey="plans.edu.pricing">
          <span className="font-medium text-[22px]">From ${{ price: yearlyPrice }}</span>
          <span> / year</span>
        </Trans>
      </p>
      <p className="text-xs text-gray-text dark:text-gray-text-dm">
        {t('plans.edu.pricingMin', { count: minUsers })}
      </p>
    </>
  )
}

export default EduPricing
